import * as React from 'react';
import { Box, Typography } from '@mui/material';

export default function Ribbon ({ text, color = '#E53935' }) {
  return (
    <Box
        sx={{
        // 1. Positioning and Size
        position: 'absolute',
        left: 0, top: 0, // Adjust distance from top edge
        // right: -25, // Adjust distance from right edge
        width: '100%', // Width of the ribbon
        textAlign: 'center',
        
        // 2. Color and Text Style
        backgroundColor: color,
        color: 'white',
        py: 0.5,
        zIndex: 10,
        
        // 3. Rotation (The core of the ribbon look)
        // transform: 'rotate(45deg)',
        
        // 4. Ribbon Edge Effect (using pseudo-elements)
        // Creates the top shadow/fold
        '&::before': {
            content: '""',
            position: 'absolute',
            top: '100%',
            left: 0,
            borderTop: `6px solid ${color}`,
            borderRight: '6px solid transparent',
            filter: 'brightness(85%)', // Make it slightly darker for a shadow effect
        },
        // Creates the bottom shadow/fold
        '&::after': {
            content: '""',
            position: 'absolute',
            top: '100%',
            right: 0,
            borderTop: `6px solid ${color}`,
            borderLeft: '6px solid transparent',
            filter: 'brightness(85%)', // Make it slightly darker for a shadow effect
        },
        }}
    >
        <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
        {text}
        </Typography>
    </Box>
  );
};
